module.exports = __webpack_public_path__ + "static/media/homeFixbg.af111915.png";